// Toggle map
$(".toggle-map").on("change", function () {
  var map = $("#storageMap");
  map.toggleClass("d-none");
});
